import { makeObservable, action } from "mobx";
import { Brief } from '../api';
import axios from 'axios';
import { getAccessToken } from './../api/config';

export default class BriefStore {
  constructor(rootStore) {
    this.rootStore = rootStore;
    makeObservable(this, {
      createBrief: action,
      getBriefs: action,
      getBriefByClient: action,
      getBriefByProfessional: action,
      updateBriefById: action,
      updateBriefByIdDirect: action
    });
  }

  async createBrief(data) {
    try {
      const retObj = await Brief.createBrief(data);
      return retObj.data.response.brief;
    } catch (error) {
      console.error("Error in createBrief:", error);
      throw error;
    }
  }

   async getBriefsByFilters(searchString, lastId, navId, i , type) {
      if (!type)type = "";
      if (!i)i = "";
      try {
        const retObj = await Brief.getBriefsByFilters(searchString, lastId, navId, i, type);
        return retObj.data.response.briefs;
      } catch (error) {
        console.error("Error in getBriefsByFilters:", error);
        throw error;
      }
    }

  async getBriefs(lastId, navId) {
    try {
      const retObj = await Brief.getBriefs(lastId, navId);
      if (retObj && retObj.data && retObj.data.response) {
        return retObj.data.response.briefs;
      } else {
        return 'error';
      }
    } catch (error) {
      console.error("Error in getBriefs:", error);
      throw error;
    }
  }

  async getBriefByClient(id) {
    try {
      const retObj = await Brief.getBriefByClient(id);
      return retObj.data.response.briefs;
    } catch (error) {
      console.error("Error in getBriefByClient:", error);
      throw error;
    }
  }

  async getBriefsByYear(year1, year2, lastId, navId) {
    try {
      const retObj = await Brief.getBriefsByYear(year1, year2, lastId, navId);
      return retObj.data.response.briefs;
    } catch (error) {
      console.error("Error in getBriefsByYear:", error);
      throw error;
    }
  }

  async getBriefByProfessional(id) {
    try {
      const retObj = await Brief.getBriefByProfessional(id);
      return retObj.data.response.briefs;
    } catch (error) {
      console.error("Error in getBriefByProfessional:", error);
      throw error;
    }
  }

  async updateBriefById (id, data) {
    try {
      const retObj = await Brief.updateBriefById(id, data);
      return retObj?.data??'error';
    } catch (error) {
      console.error("Error in updateBriefById:", error);
      throw error;
    }
  }

  // Direct Axios call for updating a brief
  async updateBriefByIdDirect(id, data) {
    try {
      const token = getAccessToken() || '';
      const response = await axios.patch(
        `http://localhost:7002/brief/id/${id}`,
        data,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      );

      return response.data;
    } catch (err) {
      console.error('Axios direct error:', err.response?.data || err.message);
      throw err;
    }
  }
}
